/**
 * Created by Ning Jiang on 12/2/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {
    IIndividualWinPresentationConfig
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {
    BetWayWinIndividualWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {Timeline, TweenLite} from "gsap";
import {DeadwoodReelView} from "../../reel/DeadwoodReelView";
import {DeadwoodIndividualWPView} from "./DeadwoodIndividualWPView";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";

export class DeadwoodIndividualWPController extends BetWayWinIndividualWPController {

    private _view:DeadwoodIndividualWPView;
    private _winTextPosition:PIXI.Point;
    private _belowStakeWinRestriction:boolean;

    constructor(config:IIndividualWinPresentationConfig) {
        super(config);
        this._view = new DeadwoodIndividualWPView();
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData) {
        // super.parseFeatureGameData(data);
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue(data.totalWin, data.playedBetValue);
    }

    protected getLineAnimation(betWayWinData:IBetWayWinData):Timeline {
        this._winTextPosition = this.getWinTextPosition(betWayWinData.reelWinPositions);
        return super.getLineAnimation(betWayWinData);
    }

    private getWinTextPosition(reelWinPositions:boolean[][]):PIXI.Point {
        for(let reelId = reelWinPositions.length - 1; reelId >= 0; reelId--) {
            for(let symId = 0; symId < 3; symId++) {
                if(reelWinPositions[reelId][symId] && !Reels.getSymbol(reelId, symId)?.symName.includes("W")) {
                    return new PIXI.Point(reelId, symId);
                }
            }
        }
        return new PIXI.Point(0, reelWinPositions[0].indexOf(true));
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        if(this._belowStakeWinRestriction) {
            timeline.add(TweenLite.to(this, 0.5, {}), startTime);
            return;
        }

        const isWild:boolean = symbol.symName.indexOf("W") > -1;
        if(isWild && symbolId != 1) {
            return;
        }

        const position:[number, number] = Helper.getSymbolPositions(reelId, symbolId);
        timeline.add([
            () => (<DeadwoodReelView>Reels.getReel(reelId)!.view).addSymbolToWinContainer(symbol),
            symbol.changeState({
                state : GameConfig.instance.SYMBOL_STATES.win,
                setStack : true,
                fadeInDuration : 0.2,
                replay : !isWild
            })
        ], startTime);

        this._view.addSymbolGlowToTimeline(betWayWinData, timeline, startTime, position, isWild, this.getAnimationAlpha(), this._betWinsData!.length > 1 && reelId === this._winTextPosition.x && symbolId === this._winTextPosition.y)
    }

    // this is not the best performance but it's fine here :(.
    private getAnimationAlpha():number {
        switch(this._gameData!.currentWinRatioConfig!.type!) {
            case WinRatioType.TINY:
                return 0.4;
            case WinRatioType.SMALL:
                return 0.4;
            case WinRatioType.MEDIUM:
                return 0.7;
            default:
                return 1;
        }
    }

    protected startWinPresentation():void {
        super.startWinPresentation();
        this._view.startWinPresentation();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);
        this._view.stopWinPresentation();
    }

    protected resetWinSymbols(isStop:boolean):void {
        if(!isStop) {
            return;
        }
        this._winSymbols = [];
    }
}